import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';

export interface FAQCSSStyle extends CRBTUICSSStyle
{
    getFaqTextCSSStyle(): object;
    getTitleTextCSSStyle(): object;
    getQuestionCSSStyle(): object;
    getAnswerCSSStyle(): object;

    getMobileFaqTextCSSStyle(): object;
    getMobileTitleTextCSSStyle(): object;
    getMobileQuestionCSSStyle(): object;
    getMobileAnswerCSSStyle(): object;
}

export class FAQCSSStyleImpl extends CRBTUICSSStyleImpl implements FAQCSSStyle
{
    getWrapperCSSStyle()
    {
        return{
            width: "100%",
            marginTop: "20px",
        };
    }
    getQuestionCSSStyle(): object 
    {
        return {
            fontSize: this.getResources().getFont(Fonts.h10),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "30px",
            float:"left",
            // height: "60px",
            width: "100%",
            textAlign: "left",
            paddingLeft: "30px",
            paddingRight: "30px",
            paddingTop: "12px",
            paddingBottom: "12px",
            outline: "none"
        };
    } 

    getFaqTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h16),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "80px",
            width: "100%",
            textAlign: "center",
        };
    }
    getTitleTextCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: this.getResources().getFont(Fonts.h12),
            color: this.getResources().getColor(Colors.color_15),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
            // marginTop: "20px",
          };
    }

    getAnswerCSSStyle(): object 
    {
        return {
            fontSize: this.getResources().getFont(Fonts.h8),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 300,
            letterSpacing: 0,
            marginTop: "20px",
            paddingLeft: "35px",
            paddingRight: "30px",
            lineHeight: "20px",
            // height: "60px",
            textAlign:"left",
            width: "100%",
            whiteSpace: "pre-wrap"
        };
    } 

    getMobileQuestionCSSStyle(): object 
    {
        return {
            fontSize: "12px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "20px",
            // height: "60px",
            float:"left",
            width: "100%",
            textAlign: "left",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "6px",
            paddingBottom: "6px",
            outline: "none"
        };
    } 

    getMobileFaqTextCSSStyle(): object {
        return {
            fontSize: "25px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "40px",
            width: "100%",
            textAlign: "center",
        };
    }
    getMobileTitleTextCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: "14.5px",
            color: this.getResources().getColor(Colors.color_15),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "20px",
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
            // marginTop: "10px",
          };
    }

    getMobileAnswerCSSStyle(): object 
    {
        return {
            fontSize: "10px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 300,
            letterSpacing: 0,
            marginTop: "10px",
            paddingLeft: "25px",
            paddingRight: "15px",
            lineHeight: "20px",
            // height: "60px",
            textAlign:"left",
            width: "100%",
            whiteSpace: "pre-wrap"
        };
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/faq/faqcss.tsx